import React, { useEffect, useState } from 'react'
import CIcon from '@coreui/icons-react'
import { cilPhone, cibWhatsapp } from '@coreui/icons'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import './AgentContact.css'

const fmtDay = (d) => {
  if (!d) return ''
  const x = new Date(d)
  return isNaN(x) ? '' : x.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

// Loads property/{id}/contact once per component
const useContact = (id) => {
  const [info, setInfo] = useState(null)
  useEffect(() => {
    if (!id) return
    wtApiCall(
      'property/' + id + '/contact',
      {},
      'get',
      (res) => setInfo(res?.data || null),
      () => setInfo(null),
    )
  }, [id])
  return info
}

// Under "Posted by": Call + WhatsApp for other agents on live listings
export default function AgentContact({ id }) {
  const info = useContact(id)
  if (!info || !info.can_contact) return null

  const logEnquiry = () => {
    wtApiCall('property/' + id + '/enquiry', {}, 'post', () => {}, () => {})
  }

  const message =
    `Good day ${info.poster_first_name}, I'm interested in ${info.listing_label} for my client. ` +
    `Is it still available?\n\nKind regards,\n${info.my_name}`

  const onCall = () => {
    logEnquiry()
    window.location.href = 'tel:' + info.phone
  }

  const onWhatsApp = () => {
    logEnquiry()
    window.open('https://wa.me/' + info.wa_phone + '?text=' + encodeURIComponent(message), '_blank')
  }

  return (
    <div className="ac-box">
      <div className="pv-label">Contact the listing agent</div>
      <div className="ac-btns">
        <button type="button" className="ac-btn ac-call" onClick={onCall}>
          <CIcon icon={cilPhone} /> Call
        </button>
        <button type="button" className="ac-btn ac-wa" onClick={onWhatsApp}>
          <CIcon icon={cibWhatsapp} /> WhatsApp
        </button>
      </div>
      <div className="ac-note">
         Listing agent {info.poster_first_name} will see that you enquired.
      </div>
    </div>
  )
}

// Poster only: who enquired (names + dates)
export function AgentsInterested({ id }) {
  const info = useContact(id)
  if (!info || !info.is_owner) return null
  const list = info.enquiries || []

  return (
    <div className="pv-card ac-interested">
      <div className="pv-label">Agents interested</div>
      {list.length === 0 ? (
        <div className="ac-empty">No agents have enquired about this listing yet.</div>
      ) : (
        list.map((e, i) => (
          <div className="ac-row" key={i}>
            <span className="ac-name">{e.name}</span>
            <span className="ac-date">{fmtDay(e.date)}</span>
          </div>
        ))
      )}
    </div>
  )
}